// extracted by mini-css-extract-plugin
export var supportBar = "ProductSupportBar-module--supportBar--VkU2W";
export var inner = "ProductSupportBar-module--inner--+FcDo";
export var title = "ProductSupportBar-module--title--6rfxz";
export var links = "ProductSupportBar-module--links--Ctj2C";
export var help = "ProductSupportBar-module--help--tWAZi";